import { type ISmartCallFlowStep } from 'entities/SmartCall/api/types'
import { type ISmartCallFlowActionType } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type'

export const getSmartCallActionTypeFromStep = (
  step: ISmartCallFlowStep
): ISmartCallFlowActionType | null => {
  if (step.id === 'inboundCall') return 'incomingCall'
  if (step.id === 'callingFlow') return 'callingFlow'
  if (step.id === 'forwardCallMulti') return 'forwardCall'
  if (step.id === 'success') return 'callEnds'
  return step.id
}
